import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { COMPACT_QUERY } from "../../../utils/hooks/useCompact";
import { CatalogueStatus, STATUS_LABEL } from "./constants";

const compact = "@media " + COMPACT_QUERY;

const DOT_SIZE = 10;

interface StatusDotProps {
  /** A null status is stored by rows that were never disabled; the API reads it as enabled. */
  status: CatalogueStatus | null;
}

/** Enable/disable indicator shared by the product and pricebook tables. */
export default function StatusDot({ status }: StatusDotProps) {
  const isEnabled = status !== "disable";

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      sx={{ px: 2, py: 0.5, [compact]: { px: 1.5, py: 0.25 } }}
    >
      <Box
        sx={{
          width: DOT_SIZE,
          height: DOT_SIZE,
          borderRadius: "50%",
          flexShrink: 0,
          bgcolor: (theme) =>
            isEnabled ? theme.palette.success.main : theme.palette.error.main,
        }}
      />
      {isEnabled ? STATUS_LABEL.enable : STATUS_LABEL.disable}
    </Stack>
  );
}
